// extracted by mini-css-extract-plugin
module.exports = {"orderTypeSwitch":"OrderType_orderTypeSwitch__1VUFk","switchItem":"OrderType_switchItem__1J5j7","selected":"OrderType_selected__3fUSz"};